module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Preloader"
  }, [_c('div', {
    staticClass: "sk-folding-cube"
  }, [_c('div', {
    staticClass: "sk-cube1 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube2 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube4 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube3 sk-cube"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af09e22c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Preloader.vue
// module id = 169
// module chunks = 4